module.exports = __webpack_public_path__ + "img/300-active-players.654cd87f.jpg";